import { parseDateString } from '../utils/helpers'
import reduce from '../utils/reducers'
import d from '../utils/directives'
import store from 'src/store'
import Q_ from '../query'

export default function($api) {
  return {
    // count total available posts
    fetchPostCount() {
      return $api.get({
        query: Q_(d.at.type('post')),
        fetch: 'document.id'
      })
      .then(({ total_results_size: total }) => Promise.resolve(parseInt(total)))
    },

    // fetch a single post
    fetchPost(uid) {
      let cached = store.getters.findPost(uid)
      if (cached) {
        return Promise.resolve(cached)
      }

      return $api.get({
        query: Q_(d.at.uid('post', uid)),
        pageSize: 1
      })
      .then(({ results }) => {
        let post
        if (!results.length) {
          return Promise.reject()
        }

        post = {
          id: results[0].id,
          path: uid,
          firstPublished: parseDateString(results[0].first_publication_date),
          ...reduce.content(results[0].data.post)
        }

        store.commit('posts/CACHE', post)
        return Promise.resolve(post)
      })
    },

    // fetch and array of posts by uid
    fetchPostCollection(uids) {
      uids = (uids.length > 4) ? uids.slice(0, 5) : uids
      return $api.get({
        query: Q_(d.in.uid('post', uids))
      }).then(({ results }) => {
        if (!results.length) return Promise.reject(null)

        return Promise.resolve({
          posts: results.map(result => {
            let post = {
              id: result.id,
              path: result.uid,
              firstPublished: parseDateString(result.first_publication_date),
              ...reduce.content(result.data[result.type])
            }

            store.commit('posts/CACHE', post)
            return post
          })
        })
      })
    },

    // fetch a post id by index in chronological order
    fetchPostId(index, filter) {
      let featured = false
      const fetchId = () => {
        let query = (!featured) ? Q_(d.at.type('post'))
          : Q_(d.at.type('post'), d.not.uid('post', filter))

        return $api.get({
          query: query.sort({ by: 'field', type: 'post', field: 'published' }),
          fetch: 'post.id',
          pageSize: index + 1
        })
        .then(({ results }) => {
          if (!results.length || !results[index]) return Promise.reject()
          return Promise.resolve({ id: results[index].id, featured })
        })
      }

      if (filter) {
        return $api.get({
          query: Q_(d.at.type('post')).sort({ by: 'field', type: 'post', field: 'published' }),
          fetch: 'post.id',
          pageSize: index + 1
        })
        .then(({ results }) => {
          if (!results.length || !results[index]) return Promise.reject()
          featured = results.some(result => result.uid === filter)

          if (featured) return fetchId()
          return Promise.resolve({ id: results[index].id, featured })
        })
      } else {
        return fetchId()
      }
    },

    // fetch a paged post feed
    fetchPostFeed({ page, pageSize, after, category, filter }) {
      let query = (filter) ? Q_(d.missing('post', 'preview-mode'), d.not.uid('post', filter))
        : (category) ? Q_(d.missing('post', 'preview-mode'), d.at.field('post', 'category', category))
        : Q_(d.missing('post', 'preview-mode'))

      return $api.get({
        query: query.sort({ by: 'field', type: 'post', field: 'published' }),
        pageSize,
        after,
        page
      })
      .then(({ page, results, total_pages: pages }) => {
        if (!results.length) return Promise.reject()

        return Promise.resolve({
          page,
          pages,
          posts: results.map(result => {
            let post = {
              id: result.id,
              path: result.uid,
              firstPublished: parseDateString(result.first_publication_date),
              ...reduce.content(result.data[result.type])
            }

            store.commit('posts/CACHE', post)
            return post
          })
        })
      })
    },

    // fetch similar posts
    fetchSimilarPosts(id, precision) {
      return $api.get({
        query: Q_(d.at.type('post'), d.similar(id, precision)),
        fetch: 'post.uid',
        pageSize: 3
      }).then(({ results }) => {
        let result = results.map(result => result.uid)
        if (results.length > 2 || store.state.posts.total <= 2) {
          return Promise.resolve(result)
        }

        return Promise.reject(result)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/actions/posts.js